export default "__VITE_ASSET__yb9H6xi___"